import React, { useEffect, useState } from 'react';
import { hasRecoverablePartnerSession, loginPartner, restorePartnerSession } from '../services/partnerApiClient';
import '../styles/Parceiros.css';

function goToPanel() {
  window.location.assign('/parceiros/painel');
}

export default function ParceiroLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [checking, setChecking] = useState(hasRecoverablePartnerSession());
  const [error, setError] = useState('');
  const logo = `${process.env.PUBLIC_URL || ''}/assets/nivora-logo.png`;

  useEffect(() => {
    if (!checking) return undefined;
    let active = true;
    restorePartnerSession()
      .then((actor) => {
        if (active && actor) goToPanel();
      })
      .catch(() => {})
      .finally(() => { if (active) setChecking(false); });
    return () => { active = false; };
  }, [checking]);

  const submit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');
    try {
      await loginPartner({ email, password });
      goToPanel();
    } catch (loginError) {
      setError(loginError.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="partner-page partner-auth-page">
      <main className="partner-auth-shell">
        <section className="partner-auth-context">
          <a className="partner-brand partner-brand-light" href="/parceiros">
            <img src={logo} alt="" aria-hidden="true" />
            <span>Nivora ERP</span><small>Parceiros</small>
          </a>
          <div>
            <span className="partner-eyebrow">Área exclusiva</span>
            <h1>Sua carteira e suas integrações em um painel separado.</h1>
            <p>Este acesso é exclusivo para parceiros. Usuários e senhas do ERP de lojistas não funcionam aqui.</p>
          </div>
          <a href="/parceiros"><i className="fas fa-arrow-left" aria-hidden="true"></i> Conhecer o programa</a>
        </section>
        <section className="partner-auth-card">
          <div>
            <span className="partner-eyebrow">Acesso do parceiro</span>
            <h2>Entrar no painel</h2>
            <p>Use as credenciais enviadas após a aprovação da parceria.</p>
          </div>
          {checking ? (
            <div className="partner-loading" role="status"><i className="fas fa-spinner fa-spin" aria-hidden="true"></i> Verificando sua sessão...</div>
          ) : (
            <form onSubmit={submit}>
              <label>
                E-mail
                <input type="email" value={email} onChange={(event) => setEmail(event.target.value)} autoComplete="username" required autoFocus />
              </label>
              <label>
                Senha
                <input type="password" value={password} onChange={(event) => setPassword(event.target.value)} autoComplete="current-password" required />
              </label>
              {error && <div className="partner-feedback is-error" role="alert"><i className="fas fa-circle-exclamation" aria-hidden="true"></i>{error}</div>}
              <button className="partner-button partner-button-primary" type="submit" disabled={loading}>
                {loading ? 'Entrando...' : 'Entrar'}
              </button>
            </form>
          )}
          <small className="partner-auth-help">Ainda não é parceiro? <a href="/parceiros#quero-ser-parceiro">Envie sua candidatura.</a></small>
        </section>
      </main>
    </div>
  );
}
